import {useMemo} from 'react';

import {Collection} from 'components/recommendations/leo-promotions-badge/types';
import {Product, ProductSearchResult, ProductType} from 'types';
import {CollectionType} from 'types/recommedation-types/recommendations';
import {is1PMakroStore} from 'utils';

export const useRibbons = (product: Product | ProductSearchResult) => {
  const storeCode = product?.storeCode || product?.variants[0]?.storeCode;
  const productType = is1PMakroStore(storeCode) ? ProductType.PRODUCT_1P : ProductType.PRODUCT_3P;

  const rightRibbonInfo = useMemo(() => {
    const collections = (product?.collections || []) as Collection[];
    return collections.filter((item) => item.type === CollectionType.IMAGE_RIGHT_RIBBON);
  }, [product]);

  const promotionInfoWithUrl = useMemo(() => {
    const collections = product?.collections as Collection[];
    return collections?.find((item) => item.type === CollectionType.PROMOTION && item.imageUrl);
  }, [product]);

  const isBulky = product?.isBulky || false;
  const isPreOrder = product?.isPreOrder || false;

  return {
    productType,
    isBulky,
    rightRibbonInfo: rightRibbonInfo.slice(0, 3),
    promotionInfoWithUrl: promotionInfoWithUrl as Collection,
    isPreOrder
  };
};
